// `avatar update [--tag <dist-tag>]` — self-update CLI lên bản mà dist-tag trỏ.
//
// Mặc định tag `latest` (bản stable). Kênh thử nghiệm: `avatar update --tag next`.
// Flow: so version đang chạy vs version của tag trên registry → trùng thì thôi,
// khác thì `npm i -g` (stdio inherit để user thấy progress/lỗi quyền thật).
import type { Command } from "commander";

import { readCliVersion } from "../lib/read-cli-version-from-package-json.js";
import {
  AVATAR_CLI_PACKAGE_NAME,
  fetchVersionForDistTag,
  runNpmGlobalInstall,
} from "../lib/self-update-cli-via-npm-global-install.js";
import { log } from "../lib/terminal-logger.js";

export function registerUpdateCommand(program: Command): void {
  program
    .command("update")
    .description("Update avatar CLI lên bản mới nhất (npm install -g)")
    .option("--tag <dist-tag>", "npm dist-tag muốn theo (latest | next)", "latest")
    .action(async (opts: { tag: string }) => {
      const current = readCliVersion();
      const target = fetchVersionForDistTag(opts.tag);

      if (!target) {
        log.error(
          `Không lấy được version cho tag '${opts.tag}' từ npm registry. ` +
            `Kiểm tra mạng/npm rồi thử lại, hoặc chạy tay: npm i -g ${AVATAR_CLI_PACKAGE_NAME}@${opts.tag}`,
        );
        process.exit(1);
      }

      if (target === current) {
        log.success(`avatar CLI đã ở bản mới nhất của tag '${opts.tag}' (v${current}).`);
        return;
      }

      log.info(`Update avatar CLI: v${current} → v${target} (tag '${opts.tag}')...`);
      const code = runNpmGlobalInstall(opts.tag);
      if (code !== 0) {
        log.error(
          `npm install thất bại (exit ${code}). Thử chạy tay: ` +
            `npm i -g ${AVATAR_CLI_PACKAGE_NAME}@${opts.tag}`,
        );
        process.exit(code);
      }
      log.success(`Đã update avatar CLI → v${target}. Mở terminal mới nếu version chưa đổi.`);
    });
}
